import { mutations as authMutations, actions as authActions, state as authState, getters as authGetters } from './auth';
import cart from '@/store/cart.js';
import menu from '@/store/menu.js';
import orderHistory from '@/store/orderHistory.js';
import signalR from '@/store/signalR.js';

export const storeConfig = {
  state: {
    ...authState
  },
  getters: {
    ...authGetters
  },
  mutations: {
    ...authMutations
  },
  actions: {
    resetData: function (store) {
      store.dispatch('signalR/resetData');
    },
    ...authActions
  },
  modules: {
    cart,
    menu,
    orderHistory,
    signalR
  }
};
